<app-page-body [class]="'tw-pt-2'" *ngIf="!isVisibleHelpPage">
  <!-- header -->
  <app-page-header
    [title]="title | translate"
    [loading]="loading"
    [showAddBtn]="false"
    [showAuditBtn]="false"
    (onShowHelp)="onShowHelpPage()"
  >
    <div class="card-toolbar" after-btns>
      @if (!formPageConfig?.isEditMode) {
      <!-- open sendQueue -->
      <page-header-btn
        [name]="
          userSession?.isSuperAdmin() ? 'sendQueue' : 'currentUserSendQueue'
        "
        icon="mdi-email-multiple-outline"
        [title]="
          userSession?.isSuperAdmin()
            ? 'pages.sendQueue.title'
            : 'pages.sendQueue.userTitle'
        "
        btnColor="btn-light"
      ></page-header-btn>

      <!-- open outboxMessages -->
      <page-header-btn
        [name]="
          userSession?.isSuperAdmin()
            ? 'userOutboxMessages'
            : 'currentUserOutboxMessages'
        "
        icon="mdi-inbox-arrow-up"
        iconSize="mdi-22px"
        [title]="
          userSession?.isSuperAdmin()
            ? 'pages.outboxMessages.title'
            : 'pages.outboxMessages.userTitle'
        "
        btnColor="btn-light-info"
      ></page-header-btn>
      }
    </div>
  </app-page-header>

  <div class="app-page-content">
    <!-- start of app page content-->
    <mat-stepper #stepper [linear]="true">
      <!-- step1 -->
      <mat-step #mapStep [completed]="false">
        <ng-template matStepLabel>{{
          "pages.sendSmsFromMap.fields.selectPostalCode" | translate
        }}</ng-template>
        <postal-code-map-selector
          (userConfirmed)="onMapConfirmed($event)"
          [bulkDatabaseVersion]="bulkDatabaseVersion.Second"
          [Theme]="appStateService.currentThemeMode()"
        ></postal-code-map-selector>
      </mat-step>
      <!-- step2 -->
      <mat-step>
        <ng-template matStepLabel>{{
          "pages.sendSmsFromMap.fields.selectMessageSettings" | translate
        }}</ng-template>

        <app-base-send-sms
          formId="sendSmsFromMapForm2"
          [childTagName]="tagName"
          [config]="baseSendSmsConfig"
          [form]="form"
          [loading]="loading"
          (onSaveToCampaign)="onSaveToCampaign($event)"
          (model)="getBaseSendSmsModel($event)"
          (onSubmit)="onSubmit()"
          (onClosePage)="onClose()"
        >
        </app-base-send-sms>
      </mat-step>
    </mat-stepper>
  </div>
  <!-- end of app-page-content -->

  <!-- calcLoading -->
  <app-special-loading *ngIf="calcLoading" special-loading type="calculate">
  </app-special-loading>

  <!-- sendLoading -->
  <app-special-loading *ngIf="sendLoading" special-loading type="sending">
  </app-special-loading>
</app-page-body>
<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="isVisibleHelpPage">
  <app-help-page
    menuTitle="SendSMSFromMap"
    (hidePage)="onHideHelpPage()"
    [title]="title"
  >
  </app-help-page>
</ng-container>
